<div class="row no-gutters">
  <div
    class="col-1 d-flex justify-content-center align-items-center"
    *ngIf="canSelect"
  >
    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        (change)="selectAnnotation($event)"
        [checked]="selected"
      />
    </div>
  </div>
  <div class="project-card" id="annotation-card-{{ annotation.id }}">
    <div class="details" (click)="toggleExtended()">
      <small *ngIf="index"
        ><span class="badge badge-secondary mb-2">#{{ index }}</span></small
      >
      <p class="title text-left">{{ annotation.name }}</p>
      <div class="severity">
        <p
          class="badge badge-pill"
          [style]="
            'background-color: ' + annotation.severity_type.description + ';'
          "
        >
          {{ annotation.severity_type.name | translate }}
        </p>
      </div>
      <span *ngIf="annotation.status">
        <p>{{ "Status" | translate }}</p>
        <p>
          <strong>{{ annotation.status | translate }}</strong>
        </p>
      </span>
      <span *ngIf="review_module_enabled">
        <p>{{ "Review Status" | translate }}</p>
        <p>
          <strong>{{ annotation.review_status | translate }}</strong>
        </p>
      </span>
      <p>{{ "Defect type" | translate }}</p>
      <p>
        <strong>{{ annotation.annotation_type.name | translate }}</strong>
      </p>
      <p>{{ "Size" | translate }}</p>
      <p>
        <strong
          >{{ annotation.area_size | number }}
          {{ isSquareMeter ? "m²" : "m" }}</strong
        >
      </p>
      <p>{{ "Map Layer" | translate }}</p>
      <p>
        <strong
          >{{ map_layer_name | titlecase }}
          {{ annotation?.map_layer?.layer_date | date: "dd/MM/yyyy" }}</strong
        >
      </p>
      <div
        class="action-btn mt-2"
        *ngIf="
          permissions &&
          (permissions['update:any.annotation'] ||
            permissions['delete:any.annotation'])
        "
      >
        <a
          class="btn btn-sm btn-circle btn-outline-primary"
          [ngClass]="'btn-outline-primary'"
          (click)="onEdit()"
          *ngIf="canEdit && permissions && permissions['update:any.annotation']"
        >
          <i class="icon-pencil"></i>
        </a>
        <button
          class="btn btn-sm btn-circle btn-outline-danger"
          (click)="onDelete()"
          *ngIf="permissions && permissions['delete:any.annotation']"
        >
          <i class="icon-delete"></i>
        </button>
      </div>
    </div>
    <div class="annot-thumbnail" (click)="onClickThumbnail()">
      <img [src]="backgroundImageWithoutURLContainer" />
    </div>
    <div class="extended-details" [style.height]="isExtended ? '10em' : '0em'">
      <div class="details">
        <p>{{ "Defect type" | translate }}</p>
        <p>
          <strong>{{ annotation.description }}</strong>
        </p>
      </div>
    </div>
  </div>
</div>
